import { UX4_PRIMARY_ORANGE } from "@cart-ui/constants/Color";
import React, { memo } from "react";
import { ReactElement } from "react";

function OtherAddressIconv4(props: { className?: string }): ReactElement {
    return (
        <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={props.className}
        >
            <path
                d="M13.295 2.84677C16.4053 1.24774 17.9605 0.448222 18.7126 1.16541C19.4647 1.88259 18.74 3.47398 17.2905 6.65675L13.113 15.8298C11.6059 19.1391 10.8523 20.7938 9.80396 20.6814C8.75558 20.5691 8.36773 18.7833 7.59202 15.2116C7.40285 14.3406 7.30827 13.9051 7.01614 13.605C6.72401 13.305 6.29306 13.1993 5.43114 12.988L4.9935 12.8807C1.80593 12.099 0.212144 11.7082 0.0936134 10.7014C-0.0249176 9.69461 1.43452 8.9443 4.35339 7.4437L13.295 2.84677Z"
                fill={UX4_PRIMARY_ORANGE}
            />
        </svg>
    );
}

export default memo(OtherAddressIconv4);
